export interface Model {
  name: string;
  value: string;
}
